import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button,Card,CardContent,TextField } from '@material-ui/core';
import logo from '../logo.svg';



const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: 300,
  },
  formGrid:{
    display:'flex'
  },


  card:{
    backgroundColor:theme.palette.secondary.main,
    maxWidth: 450,
    maxHeight:'450px',
  },
  button: {
    margin: theme.spacing.unit * 2,
    width: 300,
    fontWeight:'500px',
    // backgroundColor:'blue'
  },
  cardHeader:{
      marginLeft: theme.spacing.unit,
      color:'#000'
  },
  logo:{
    animation: 'App-logo-spin infinite 20s linear',
    height: '60px',
  },

  
});

class Form extends React.Component {
  state = {
    name: '',
    email: '',
    message: '',
    nameError: false,
    emailError: false,
    messageError: false,

  };

  handleChange = name => event => {
    const error = name + "Error";
    this.setState({
        [name]: event.target.value,
        [error]:true
      });
    
  };

  handleSubmit = () => {
    debugger;
  }

  render() {
    const { classes } = this.props;

    return (
        <form className={classes.container} noValidate autoComplete="off">
            <Card className={classes.card}>
                <CardContent>
                    <Grid container direction="row" className={classes.formGrid} justify="center" align="center">
                        <Grid item xs={12} >
                              <img src={logo} className={classes.logo} alt="logo" />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                id="name"
                                label="Name"
                                className={classes.textField}
                                value={this.state.name}
                                onChange={this.handleChange('name')}
                                margin="normal"
                                error={(this.state.name == "" && this.state.nameError)?true:false}
                                onClick = {()=>this.setState({
                                        nameError:true
                                })}
                               
                            />
                        </Grid>

                       <Grid item xs={12}>
                            <TextField 
                                    id="name"
                                    label="Email"
                                    className={classes.textField}
                                    value={this.state.email}
                                    onChange={this.handleChange('email')}
                                    onClick = {()=>this.setState({
                                        emailError:true
                                    })}
                                    margin="normal"
                                    error={(this.state.email == "" && this.state.emailError)?true:false}
                                   
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                id="textarea"
                                label="Message"
                                placeholder="Enter your message"
                                multiline
                                className={classes.textField}
                                onChange={this.handleChange('message')}
                                onClick = {()=>this.setState({
                                    messageError:true
                                    })}
                                margin="normal"
                                error={(this.state.message == "" && this.state.messageError)?true:false}
                                rows="4"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={(e)=>this.handleSubmit(e)} variant="contained" color="primary"   className={classes.button}>
                                Send
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </form>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Form);


// WEBPACK FOOTER //
// ./src/component/contact/form.js